import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import parseCatch from 'utils/parseCatch';


const PAYOUT_SERVER = ConfigurationService.get(ConfigurationKeys.PAYOUT_SERVER);

const TWO_FA_PAYOUT_URL = `${PAYOUT_SERVER}/rest/v1/validateTwoFaCode`;
const RESEND_TWO_FA_URL = `${PAYOUT_SERVER}/rest/v1/resendTwoFaCode`;

class TwoFaService {
  constructor() {
    this.initialTextStatus = {
      data: {},
      validationResponse: {},
      codeResent: false,
      error: false,
      codeValidate: false,
      errorMsg: '',
    };
  }

  validateCode = async(data, url = TWO_FA_PAYOUT_URL, headers = {}, withCredentials = true) => {
    let result = undefined;
    try {
      const response = await ApiService.post(url, { data, headers, withCredentials });
      result = response.data;
    } catch (err) {
      parseCatch(err);
    }

    return result;
  };

  resendCode = async(data, url = RESEND_TWO_FA_URL, headers = {}, withCredentials = true) => {
    let result = undefined;
    try {
      const response = await ApiService.post(url, { data, headers, withCredentials });
      result = response.data;
    } catch (err) {
      parseCatch(err);
    }

    return result;
  };

  handleTextStatus = (state, action) => {
    switch (action.type) {
      case 'openModal':
        return {
          ...this.initialTextStatus,
          data: action.payload,
          validationResponse: action.payload.response,
        };
      case 'setSuccess':
        return { ...this.initialTextStatus, codeValidate: true };
      case 'setError':
        return {
          ...state,
          error: true,
          codeResent: false,
          errorMsg: action.errorMsg,
        };
      case 'codeResend':
        return { ...state, codeResent: true, error: false };
      case 'setPaymentError':
        return {
          ...this.initialTextStatus,
          codeValidate: true,
          errorMsg: action.errorMsg,
        };
      default:
        throw new Error(`Unexpected action ${action.type}`);
    }
  };
}

export default new TwoFaService();
